webpackJsonp([47250406227084],{

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: white; \n  border-radius: 4px;\n  border: 1px solid #43AB60;\n  padding: 10px 20px;\n  margin: auto;\n  transition: all 200ms ease;\n  \n  &:hover {\n    cursor: pointer;\n    background: white !important;\n    border: 1px solid ', ';\n    \n    & a {\n    color: ', ' !important;\n    } \n  }\n  \n  a {\n    color: #43AB60;\n    font-size: 1.6rem;\n    text-decoration: none;\n      width: 100%;\n  height: 100%;\n   \n  }\n'], ['\n  background: white; \n  border-radius: 4px;\n  border: 1px solid #43AB60;\n  padding: 10px 20px;\n  margin: auto;\n  transition: all 200ms ease;\n  \n  &:hover {\n    cursor: pointer;\n    background: white !important;\n    border: 1px solid ', ';\n    \n    & a {\n    color: ', ' !important;\n    } \n  }\n  \n  a {\n    color: #43AB60;\n    font-size: 1.6rem;\n    text-decoration: none;\n      width: 100%;\n  height: 100%;\n   \n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CtaButtonSm = function (_Component) {
	  _inherits(CtaButtonSm, _Component);
	
	  function CtaButtonSm() {
	    _classCallCheck(this, CtaButtonSm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CtaButtonSm.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.isNav) {
	      window.addEventListener("scroll", this.changeBackground);
	    }
	  };
	
	  CtaButtonSm.changeBackground = function changeBackground() {
	    var button = document.getElementById('ctaButton');
	    var buttonText = button.childNodes[0];
	    if (window.scrollY > 100) {
	      button.style.background = '#43AB60';
	      buttonText.style.color = 'white';
	    }
	    if (window.scrollY === 0) {
	      button.style.background = 'white';
	      buttonText.style.color = '#43AB60';
	    }
	  };
	
	  CtaButtonSm.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        bgColor = _props.bgColor,
	        textColor = _props.textColor,
	        to = _props.to;
	
	    return _react2.default.createElement(
	      CtaButtonSmContainer,
	      {
	        background: bgColor,
	        id: 'ctaButton',
	        style: { background: bgColor } },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: to,
	          style: { color: textColor } },
	        children
	      )
	    );
	  };
	
	  return CtaButtonSm;
	}(_react.Component);
	
	exports.default = CtaButtonSm;
	
	
	var CtaButtonSmContainer = _styledComponents2.default.span(_templateObject, function (props) {
	  return props.background ? props.background : "#43AB60";
	}, function (props) {
	  return props.background ? props.background : "#43AB60";
	});
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 100px 0;\n  .mobile {\n    display: none;\n  }\n  .web {\n    display: block;\n  }\n\n  @media screen and (max-width: 768px) {\n    .mobile {\n      display: block;\n    }\n    .web {\n      display: none;\n    }\n    padding: 50px 0;\n  }\n\n  section {\n    margin: auto;\n    max-width: 1200px;\n  }\n'], ['\n  padding: 100px 0;\n  .mobile {\n    display: none;\n  }\n  .web {\n    display: block;\n  }\n\n  @media screen and (max-width: 768px) {\n    .mobile {\n      display: block;\n    }\n    .web {\n      display: none;\n    }\n    padding: 50px 0;\n  }\n\n  section {\n    margin: auto;\n    max-width: 1200px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FullWidthSection = function (_Component) {
	  _inherits(FullWidthSection, _Component);
	
	  function FullWidthSection() {
	    _classCallCheck(this, FullWidthSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FullWidthSection.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        mobileHide = _props.mobileHide,
	        mobileBg = _props.mobileBg;
	
	    return _react2.default.createElement(
	      FullWidthSectionContainer,
	      { style: { background: this.props.bgColor } },
	      _react2.default.createElement(
	        'section',
	        { className: 'mobile' },
	        children
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'web' },
	        children
	      )
	    );
	  };
	
	  return FullWidthSection;
	}(_react.Component);
	
	exports.default = FullWidthSection;
	
	
	var FullWidthSectionContainer = _styledComponents2.default.div(_templateObject);
	module.exports = exports['default'];

/***/ }),

/***/ 1826:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  .Jobs__Content {\n    display: grid;\n    grid-template-areas: \n      "head"\n      "why";\n    justify-content:center;\n    grid-row-gap: 50px;\n    \n    \n    @media screen and (max-width: 768px) {\n      display: block;\n    }\n    \n    .headBlurb {\n      grid-area:head;\n      margin: auto;\n      text-align: center;\n      \n      \n      h1, h3 {\n        margin: auto;\n        margin-bottom: 25px; \n      }\n      h1 {width: 70%}\n      h3 {width: 85%}\n    }\n    .whyBlurb {\n      grid-area:why;\n      width: 800px;\n      margin: auto;\n      \n      \n    @media screen and (max-width: 768px) {\n      width: 90%;\n    }\n      \n      h3 {        \n        text-align: center;\n        margin-bottom: 25px; \n      }\n      p {\n      margin-bottom: 30px; \n      text-align:center;\n      }\n    }\n  }\n  \n  .joinBlurb {\n      grid-area:join;\n      width: 1000px;\n      margin: auto;\n      display: grid;\n      grid-template-areas: "title title" "right left";\n      grid-template-columns: 1fr 1fr;\n      justify-content:center;\n      grid-column-gap: 80px;\n      \n      \n      @media screen and (max-width: 768px) {\n        width: 90%;\n        display: flex;\n        flex-flow: column;\n        \n        & h4 {\n          margin: 30px auto;\n          border-bottom: .5px solid black;\n        }\n        \n        & h5 {\n          margin: 20px;\n        }\n      }\n    \n    \n      .joinTitle {\n        grid-area:title;\n        text-align: center;\n      }\n      .posLeft {grid-area:left}\n      .posRight {grid-area:right}\n      .posLeft, .posRight {\n        h4 {\n          font-size: 2rem; \n          margin-bottom: 15px;\n          text-align: center; \n        }\n        p {margin: 10px 0;}\n        h5 {margin: 10px 0;}\n        ul {list-style: circle;}\n      }\n    }\n    \n    .applyBlurb{\n      grid-area:apply;\n      width: 800px;\n      margin: auto;\n      display: flex;\n      flex-direction: column;\n      \n      \n    @media screen and (max-width: 768px) {\n      width: 90%;\n    }\n      \n      h4 {        \n        text-align: center;\n        margin-bottom: 25px; \n      }\n      p {\n      margin-bottom: 30px; \n      text-align:center;\n      }\n      span {\n        display: inline-block;\n      }\n    }\n    \n  .ctaButton {\n    background: #43AB60;\n    border-radius: 4px;\n    padding: 10px 20px;\n    border: 1px solid #43AB60;\n    margin: auto;\n    display: inline-block;\n    transition: all 200ms ease;\n    font-size: 2rem;\n    color: white;\n    \n    &:hover {\n      cursor: pointer;\n      background: white !important;\n      border: 1px solid #43AB60;\n      color: #43AB60;\n      }\n  }\n'], ['\n  .Jobs__Content {\n    display: grid;\n    grid-template-areas: \n      "head"\n      "why";\n    justify-content:center;\n    grid-row-gap: 50px;\n    \n    \n    @media screen and (max-width: 768px) {\n      display: block;\n    }\n    \n    .headBlurb {\n      grid-area:head;\n      margin: auto;\n      text-align: center;\n      \n      \n      h1, h3 {\n        margin: auto;\n        margin-bottom: 25px; \n      }\n      h1 {width: 70%}\n      h3 {width: 85%}\n    }\n    .whyBlurb {\n      grid-area:why;\n      width: 800px;\n      margin: auto;\n      \n      \n    @media screen and (max-width: 768px) {\n      width: 90%;\n    }\n      \n      h3 {        \n        text-align: center;\n        margin-bottom: 25px; \n      }\n      p {\n      margin-bottom: 30px; \n      text-align:center;\n      }\n    }\n  }\n  \n  .joinBlurb {\n      grid-area:join;\n      width: 1000px;\n      margin: auto;\n      display: grid;\n      grid-template-areas: "title title" "right left";\n      grid-template-columns: 1fr 1fr;\n      justify-content:center;\n      grid-column-gap: 80px;\n      \n      \n      @media screen and (max-width: 768px) {\n        width: 90%;\n        display: flex;\n        flex-flow: column;\n        \n        & h4 {\n          margin: 30px auto;\n          border-bottom: .5px solid black;\n        }\n        \n        & h5 {\n          margin: 20px;\n        }\n      }\n    \n    \n      .joinTitle {\n        grid-area:title;\n        text-align: center;\n      }\n      .posLeft {grid-area:left}\n      .posRight {grid-area:right}\n      .posLeft, .posRight {\n        h4 {\n          font-size: 2rem; \n          margin-bottom: 15px;\n          text-align: center; \n        }\n        p {margin: 10px 0;}\n        h5 {margin: 10px 0;}\n        ul {list-style: circle;}\n      }\n    }\n    \n    .applyBlurb{\n      grid-area:apply;\n      width: 800px;\n      margin: auto;\n      display: flex;\n      flex-direction: column;\n      \n      \n    @media screen and (max-width: 768px) {\n      width: 90%;\n    }\n      \n      h4 {        \n        text-align: center;\n        margin-bottom: 25px; \n      }\n      p {\n      margin-bottom: 30px; \n      text-align:center;\n      }\n      span {\n        display: inline-block;\n      }\n    }\n    \n  .ctaButton {\n    background: #43AB60;\n    border-radius: 4px;\n    padding: 10px 20px;\n    border: 1px solid #43AB60;\n    margin: auto;\n    display: inline-block;\n    transition: all 200ms ease;\n    font-size: 2rem;\n    color: white;\n    \n    &:hover {\n      cursor: pointer;\n      background: white !important;\n      border: 1px solid #43AB60;\n      color: #43AB60;\n      }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\n'], ['\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  border-bottom: .5px solid black;\n  width: 60%;\n  margin: 50px auto;\n'], ['\n  border-bottom: .5px solid black;\n  width: 60%;\n  margin: 50px auto;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FullWidthSection = __webpack_require__(54);
	
	var _FullWidthSection2 = _interopRequireDefault(_FullWidthSection);
	
	var _CtaButtonSm = __webpack_require__(26);
	
	var _CtaButtonSm2 = _interopRequireDefault(_CtaButtonSm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobsPage = function (_Component) {
	  _inherits(JobsPage, _Component);
	
	  function JobsPage() {
	    _classCallCheck(this, JobsPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  JobsPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      JobsPageContainer,
	      null,
	      _react2.default.createElement(
	        _FullWidthSection2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'Jobs__Content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'headBlurb' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Help us make the next generation of enterprise software.'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'At AppTree, we\'re building something new--a platform that empowers everyone to build enterprise software.'
	            ),
	            _react2.default.createElement(Divider, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'whyBlurb' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'AppTree is looking for someone like you.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'At AppTree, we know that teams perform best when every member is not only skilled, but brings a different perspective to solving problems. We\'re building a team of diverse, skilled, creative pros that are excited about building the next great product in enterprise.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you\'re interested in leading our web development efforts, checkout the jobs below.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _FullWidthSection2.default,
	        { bgColor: "#f6f6f6" },
	        _react2.default.createElement(
	          'div',
	          { className: 'joinBlurb' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'joinTitle' },
	            'Open Positions'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'posLeft' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Mobile Developer, iOS or Android'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Join our mobile team developing a world-class enterprise application.'
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'Requirements'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Several years experience coding in Objective C, Swift or Java'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Experience with Android Studio or Xcode'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'An interest in databases and some SQL experience'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Track record of teaching, blogging and public speaking is a plus'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Staying current with development, tools and news in the community'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'posRight' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Web Developer'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our web team uses cutting edge technologies to create customer-facing platforms for browsers and mobile. The code you write will be shared between all of our client-side apps. '
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'Requirements'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Several years experience coding in HTML5/JavaScript, Angular & CSS'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Experience with IntelliJ or any other JetBrains IDE'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'An interest in databases and some SQL experience'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Desire to learn and code in Dart, Angular Dart, and Flutter'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Some exposure to, or the ability to quickly learn to interact with the iOS and Android SDKs'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Track record of teaching, blogging and public speaking is a plus'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Staying current with development, tools and news in the community'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _FullWidthSection2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'applyBlurb' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Apply Now'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you feel you\u2019re a match, we\u2019d love to hear from you! To make the conversation easier, send your resume + github (or links to relevant works of code) to jobs@apptreesoftware.com. Your email will be read with extra attention by our CTO.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019d like to join us but don\u2019t meet the requirements of this particular position, please feel free to email us at jobs@apptreesoftware.com and tell us how you\u2019d like to help!'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We offer competitive salaries, stock options and the usual perks.'
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'ctaButton',
	              href: 'mailto:jobs@apptreesoftware.com'
	            },
	            'Send Resume Now \u2192'
	          )
	        )
	      )
	    );
	  };
	
	  return JobsPage;
	}(_react.Component);
	
	exports.default = JobsPage;
	
	
	var JobsPageContainer = _styledComponents2.default.div(_templateObject);
	
	var ButtonContainer = _styledComponents2.default.div(_templateObject2);
	
	var Divider = _styledComponents2.default.div(_templateObject3);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jobs-jsx-ce57768a2c3a4ca2784a.js